var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUpIcon = function SvgArrowUpIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.415 10.85 3.826-4.464a1 1 0 0 1 1.518 0l3.826 4.463a1 1 0 0 1-.76 1.651h-7.65a1 1 0 0 1-.76-1.65"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUpIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNDE0OTYgMTAuODQ5Mkw4LjI0MDc0IDYuMzg1OEM4LjYzOTg0IDUuOTIwMTkgOS4zNjAxNiA1LjkyMDE5IDkuNzU5MjYgNi4zODU4TDEzLjU4NSAxMC44NDkyQzE0LjE0MSAxMS40OTc5IDEzLjY4MDEgMTIuNSAxMi44MjU4IDEyLjVINS4xNzQyMkM0LjMxOTg3IDEyLjUgMy44NTg5NiAxMS40OTc5IDQuNDE0OTYgMTAuODQ5MloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";